// BRAVORA — Mostrar dinámicamente "<Nombre de opción>: <valor>" (SIN negrita)

// Espera a que la sección inserte el template antes de pintar.

(function () {

  const $ = (s, c = document) => c.querySelector(s);

  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));



  // Espera a que exista un nodo en el DOM

  function waitFor(sel, { tries = 60, delay = 100 } = {}) {

    return new Promise(resolve => {

      let n = 0;

      (function loop() {

        const el = $(sel);

        if (el) return resolve(el);

        if (n++ >= tries) return resolve(null);

        setTimeout(loop, delay);

      })();

    });

  }



  const jsonEl = $('#bravora-product-json');

  if (!jsonEl) return;



  let product;

  try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  if (!product || !product.variants) return;



  // ===== Config rápida =====

  // true  -> muestra SOLO la 1ª opción que realmente varía (p. ej., "Metal: Oro blanco 14k")

  // false -> muestra TODAS las opciones que varían unidas por " · " (excepto talla)

  const SHOW_ONLY_FIRST_VARYING = true;



  const IGNORE_NAMES = ['talla','size','ring size','tamaño','medida'];



  // Índice de variantes por id

  const variantById = {};

  product.variants.forEach(v => { variantById[String(v.id)] = v; });



  const optionNames = (product.options || []).map(n => (n || '').trim());

  const optionNamesLower = optionNames.map(n => n.toLowerCase());



  // Qué opciones realmente cambian entre variantes

  const varyingIdxs = [];

  for (let i = 0; i < optionNames.length; i++) {

    const nameLower = optionNamesLower[i] || '';

    if (IGNORE_NAMES.includes(nameLower)) continue;

    const values = new Set(product.variants.map(v => v[`option${i+1}`]).filter(Boolean));

    if (values.size > 1) varyingIdxs.push(i);

  }

  // Fallback: si ninguna varía, usa la primera no ignorada

  if (!varyingIdxs.length) {

    const firstIdx = optionNamesLower.findIndex(n => !IGNORE_NAMES.includes(n));

    if (firstIdx !== -1) varyingIdxs.push(firstIdx);

  }



  // Formatea como texto plano (sin etiquetas ni negrita)

  function formatVariantText(v) {

    if (!v) return '';

    const idxs = SHOW_ONLY_FIRST_VARYING ? [varyingIdxs[0]].filter(i => i !== undefined) : varyingIdxs;

    const parts = [];

    idxs.forEach(i => {

      const label = optionNames[i] || `Opción ${i+1}`;

      const value = v[`option${i+1}`];

      if (value) parts.push(`${label}: ${value}`);

    });

    return parts.join(' · ') || v.title;

  }



  function currentFromURL() {

    const sp = new URLSearchParams(location.search);

    const id = sp.get('variant');

    if (id && variantById[id]) return variantById[id];

    return product.variants.find(v => v.available) || product.variants[0];

  }



  function init(badge) {

    if (!badge) return;



    // Asegura estilo de texto normal del tema (sin “pastilla” ni negrita previa)

    badge.style.border = '';

    badge.style.borderRadius = '';

    badge.style.padding = '';

    document.getElementById('variant-label-style')?.remove(); // por si quedó del script anterior



    const setText = (v) => {

      const txt = formatVariantText(v);

      if (txt) { badge.textContent = txt; badge.style.display = ''; }

      else { badge.textContent = ''; badge.style.display = 'none'; }

    };



    // Inicial

    setText(currentFromURL());



    // Eventos del tema/apps

    window.addEventListener('variant:change', (e) => {

      const v = e?.detail?.variant; if (v?.id) setText(variantById[String(v.id)] || v);

    });

    window.addEventListener('product:variant-change', (e) => {

      const v = e?.detail?.variant; if (v?.id) setText(variantById[String(v.id)] || v);

    });



    // Fallback: selects nativos

    $$('.product-form [name^="options"], .product-form select').forEach(el => {

      el.addEventListener('change', () => setTimeout(() => setText(currentFromURL()), 0));

    });



    // ?variant= en la URL

    window.addEventListener('popstate', () => setText(currentFromURL()));



    // Clic en miniaturas (usa data-variant-id)

    document.addEventListener('click', (ev) => {

      const a = ev.target.closest('[data-variant-id]');

      if (!a) return;

      const id = a.getAttribute('data-variant-id');

      const v = id && variantById[id];

      if (v) setText(v);

    });

  }



  // Espera a que la sección haya insertado el placeholder

  waitFor('#selected-variant-title').then(init);

})();

